// extracted by mini-css-extract-plugin
export default {"layoutContainer__bigLogo":"Layout_layoutContainer__bigLogo__4osgF","layoutMain":"Layout_layoutMain__JjQLs"};